import React, { useState, useContext, useEffect } from "react"
import blogFetch from "../../axios/config";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import Context from "../../context/Context";
import Button from "@mui/material/Button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import AsyncSelect from "react-select/async";
import { Pagination, TextField } from "@mui/material";
import language from "../../nls/language.json";

export default function Reason() {

  //Modal
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [ShowModalEdit, setShowModalEdit] = useState(false);
  // Objetos
  const [reasonId, setReasonId] = useState({})
  const [reason, SetReason] = useState({});
  // Campos para preencher
  const [originSector, setOriginSector] = useState("");
  const [pendency, setPendency] = useState("");
  const [responsibleSector, setResponsibleSector] = useState("");
  // Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState();
  const startIndex = (currentPage - 1) * rowsPerPage;

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getReason();
    getResponsibleSector();
    getOriginSector();
  }, [currentPage])

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const getReason = async () => {
    try {
      const skip = (currentPage - 1) * rowsPerPage;
      const take = rowsPerPage;
      const response = await blogFetch.get(`/ISAGA_PendenciasMotivos?skip=${skip}&take=${take}`);
      const data = response.data;
      SetReason(data.entryPoint)
      setTotalPages(Math.ceil(data.countPendencias / rowsPerPage))
    } catch (error) {
      console.error(error);
    }
  }



  const getResponsibleSector = async () => {
    try {
      const response = await blogFetch.get('/ISAGA_PendenciasSetorResponsavel');
      const data = response.data
      return (data);
    } catch (error) {
      console.error(error);
    }
  }

  const getOriginSector = async () => {
    try {
      const response = await blogFetch.get('/sector')
      const data = response.data
      return (data);
    } catch (error) {
      console.error(error);
    }
  }

  const postReason = async () => {
    try {
      if (!pendency || !originSector || !responsibleSector) {
        toast.error("Preencha todos os campos!", {
          duration: 4000,
        });
        return
      }
      const reason = {
        PendMotOrigem_SAPSector: {
          PendMot_Descricao: pendency.toUpperCase(),
          pendMot_Responsavel: responsibleSector
        },
        PendMotOrigem_SAPSectorOrigem: {
          PendMotOrigem_SAPSector: originSector
        }
      }
      const response = await blogFetch.post('/ISAGA_PendenciasMotivos', reason);
      toast.success("Motivo cadastrado com Sucesso!", {
        duration: 4000,
      });
      setShowModalAdd(false)
      return (response);
    } catch (error) {
      console.error(error);
    }
  }

  const putReason = async () => {
    const reason = {
      PendenciaMotivo: {
        PendMot_Descricao: pendency.toUpperCase(),
        PendMot_Responsavel: responsibleSector
      },
      PendenciaMotivoOrigem: {
        PendMotOrigem_SAPSector: originSector
      }
    }
    try {
      const response = await blogFetch.put("/ISAGA_PendenciasMotivos/" + reasonId.pendMot_key, reason);
      toast.success("Motivo atualizado com sucesso!", {
        duration: 4000,
      });
      setShowModalEdit(false)
      return (response);
    } catch (error) {
      console.error(error);
    }
  }

  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
          {language[selectedCountry.name].Cadastro.motivo.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <AsyncSelect
              className="mb-3"
              required
              cacheOptions
              defaultOptions
              placeholder="Setor de Origem"
              loadOptions={getOriginSector}
              getOptionLabel={(e) => e.stR_SAPCode}
              getOptionValue={(e) => e.stR_SAPCode}
              onChange={({ stR_SAPCode }) => setOriginSector(stR_SAPCode)}
            />

            <TextField
              className="mb-3"
              required
              fullWidth
              id="outlined-basic"
              placeholder="Pendência"
              onChange={(e) => setPendency(e.target.value)}
            />

            <AsyncSelect
              cacheOptions
              required
              defaultOptions
              placeholder="Setor Responsável"
              loadOptions={getResponsibleSector}
              getOptionLabel={(e) => e.setResp_nome}
              getOptionValue={(e) => e.setResp_nome}
              onChange={({ setResp_nome }) => setResponsibleSector(setResp_nome)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {language[selectedCountry.name].Cadastro.motivo.modal.adicionar.btnCancelar}
          </Button>
          <Button
            variant="contained"
            onClick={async () => {
              try {
                await postReason();
                getReason();
              } catch (error) {
                console.error();
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.motivo.modal.adicionar.btnSalvar}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={ShowModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.motivo.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <AsyncSelect
              className="mb-3"
              required
              cacheOptions
              defaultOptions
              placeholder={reasonId.pendMotOrigem_SAPSector}
              loadOptions={getOriginSector}
              getOptionLabel={(e) => e.stR_SAPCode}
              getOptionValue={(e) => e.stR_SAPCode}
              onChange={({ stR_SAPCode }) => setOriginSector(stR_SAPCode)}
            />

            <TextField
              className="mb-3"
              defaultValue={reasonId.pendMot_Descricao}
              required
              fullWidth
              id="outlined-basic"
              placeholder="Pendência"
              onChange={(e) => setPendency(e.target.value)}
            />

            <AsyncSelect
              cacheOptions
              required
              defaultOptions
              placeholder={reasonId.pendMot_Responsavel}
              loadOptions={getResponsibleSector}
              getOptionLabel={(e) => e.setResp_nome}
              getOptionValue={(e) => e.setResp_nome}
              onChange={({ setResp_nome }) => setResponsibleSector(setResp_nome)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalEdit(false)}
          >
            {language[selectedCountry.name].Cadastro.motivo.modal.editar.btnCancelar}
          </Button>
          <Button
            variant="contained"
            onClick={async () => {
              try {
                await putReason();
                getReason();
              } catch (error) {
                console.error();
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.motivo.modal.editar.btnSalvar}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
        <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.motivo.title}
            </h3>
          </div>
          <div>
            <Button
              className="btn add_button"
              variant="primary"
              onClick={() => {
                setShowModalAdd(true);
              }}
            >
              {language[selectedCountry.name].Cadastro.motivo.btnAdicionar}
            </Button>
          </div>
        </div>

        <table className="table table-hover">
            <thead className="table-header">
              <tr className="table_row">
                <th>#</th>
                <th>{language[selectedCountry.name].Cadastro.motivo.tableHeader.setorOrigem}</th>
                <th>{language[selectedCountry.name].Cadastro.motivo.tableHeader.pendencia}</th>
                <th>{language[selectedCountry.name].Cadastro.motivo.tableHeader.setorResponsavel}</th>
                <th className="edit">{language[selectedCountry.name].Cadastro.motivo.tableHeader.editar}</th>
              </tr>
            </thead>
            <tbody className="table_row">
              {Object.entries(reason)
                .map((item) => (
                  <tr key={item}>
                    <td>{item[1].pendMot_key}</td>
                    <td>{item[1].pendMotOrigem_SAPSector}</td>
                    <td>{item[1].pendMot_Descricao}</td>
                    <td>{item[1].pendMot_Responsavel}</td>
                    <td className="edit">
                      <center>
                        <ModeEditIcon
                          onClick={() => {
                            setReasonId(item[1]);
                            setShowModalEdit(true);
                          }}
                        />
                      </center>
                    </td>
                  </tr>
                ))}
            </tbody>
      
        </table>
            <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            />
      </div>
      {modalAdd()}
      {modalEdit()}
    </>
  )
}

